import React from 'react';
import { useTranslation } from 'react-i18next';
import { GlassCard } from '../components/ui/GlassCard';

export const Company = () => {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto px-6 py-20">
      <div className="max-w-3xl mx-auto space-y-12">
        <div className="text-center">
          <h1 className="text-5xl font-display font-bold mb-6">{t('company.title')}</h1>
          <p className="text-xl text-gray-400">
            {t('company.subtitle')}
          </p>
        </div>

        <GlassCard className="p-10 space-y-6">
          <h2 className="text-2xl font-bold text-white">{t('company.missionTitle')}</h2>
          <p className="text-gray-300 leading-relaxed">
            {t('company.missionDesc')}
          </p>
        </GlassCard>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <GlassCard className="p-8">
            <h3 className="text-xl font-bold mb-4 text-glass-cyan">{t('company.contactTitle')}</h3>
            <p className="text-gray-400 mb-2">{t('company.supportInquiries')}</p>
            <a href="mailto:support@getinfinityblue.com" className="text-white hover:text-glass-cyan transition-colors block mb-6">
              support@getinfinityblue.com
            </a>
            <p className="text-gray-400 mb-2">{t('company.mailingAddress')}</p>
            <p className="text-white">
              30 N Gould St Ste N<br />
              Sheridan, WY 82801
            </p>
          </GlassCard>

          <GlassCard className="p-8">
            <h3 className="text-xl font-bold mb-4 text-glass-cyan">{t('company.legalEntityTitle')}</h3>
            <p className="text-gray-400 mb-4">
              {t('company.legalEntityDesc')}
            </p>
            <p className="text-gray-400">
              {t('company.registeredAgent')}<br />
              {t('company.registeredAgentName')}
            </p>
          </GlassCard>
        </div>
      </div>
    </div>
  );
};
